import parser from 'html-react-parser';
import type { RefObject } from 'react';
import React from 'react';

import * as S from './WebinarTopicSection.style';
type WebinarTopicSectionProps = {
  refObject: RefObject<HTMLElement>;
  topics: string[];
};

const WebinarTopicSection = ({
  refObject,
  topics,
}: WebinarTopicSectionProps) => {
  return (
    <S.Section ref={refObject}>
      <S.Topics>
        {topics.map((topic: string, index: number) => (
          <React.Fragment key={index}>
            <S.Topic>{parser(topic)}</S.Topic>
            {topics.length - 1 > index && <S.Divider />}
          </React.Fragment>
        ))}
      </S.Topics>
    </S.Section>
  );
};
export default WebinarTopicSection;
